export default __webpack_public_path__ + "static/media/rocket.a28df66a.svg";